"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchedAndFilteredItems = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
function useSearchedAndFilteredItems(_a) {
    var items = _a.items, searchedIds = _a.searchedIds, filteredIds = _a.filteredIds;
    return (0, react_1.useMemo)(function () {
        if (!items) {
            return [];
        }
        if (!searchedIds && !filteredIds) {
            return items;
        }
        function findItemsPerId(items, ids) {
            if (!ids) {
                return items;
            }
            var uniqueIds = (0, lodash_1.uniq)(ids);
            var idsCanRepeat = uniqueIds.length !== ids.length;
            return (0, lodash_1.reduce)(uniqueIds, function (foundItems, id) {
                var compareFunction = function (item) { return item.id === id; };
                var matches = idsCanRepeat ? items.filter(compareFunction) : (0, lodash_1.compact)([items.find(compareFunction)]);
                return __spreadArray(__spreadArray([], __read(foundItems), false), __read(matches), false);
            }, []);
        }
        var searchedItems = findItemsPerId(items, searchedIds);
        return findItemsPerId(searchedItems, filteredIds);
    }, [filteredIds, items, searchedIds]);
}
exports.useSearchedAndFilteredItems = useSearchedAndFilteredItems;
